import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import RadioButtonListField from "../../../components/Fields/RadioButtonListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { DataResult, Result } from "../../../types/Result";

interface DeleteItemRevisionModel {
    itemId: number
    itemRevisionId?: number
}

interface ItemRevisionPopupProps {
    show: boolean
    onHide: () => void
    itemId: number
    itemRevisionId: number
}

const DeleteItemRevisionPopup: React.FC<ItemRevisionPopupProps> = ({ show, onHide, itemId, itemRevisionId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const [showSpinner, setShowSpinner] = useState(false);
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<DeleteItemRevisionModel>({
        itemId: itemId,
        itemRevisionId: itemRevisionId
    });

    const itemRevisions = useSelectListOptions('api/v1/selectlist/ItemRevisionsIfMoreThenOne?itemId=' + itemId, 'The item (including all revisions)');

    function submit() {
        if (formData) {
            if (itemRevisions?.length === 1)
                formData.itemRevisionId = undefined

            setShowSpinner(true)
            DataService
                .post<DataResult<DeleteItemRevisionModel>>(`api/v1/ItemRevisions/Delete`, formData)
                .then(response => {
                    setShowSpinner(false)
                    handleResult(response)
                    setServerErrors(response)
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => { setShowSpinner(false); handleException(e) });
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'itemRevisionId', label: 'Revision' },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <>
            <Popup show={show} onHide={onHide} size={'lg'} title={'Delete item'} >
                <Popup.Body>
                    {(itemRevisions?.length ?? 0) > 1 && < RadioButtonListField {...getFieldProps('itemRevisionId')} options={itemRevisions} layout='vertical' />}
                    {(itemRevisions?.length ?? 0) <= 1 && <p><Translate>Are you sure you want to delete the item?</Translate></p>}
                </Popup.Body>
                <Popup.Footer>
                    <SaveButton {...getSubmitButtonProps()} text='Delete' variant='danger' />
                </Popup.Footer>
            </Popup>
            {showSpinner && <SpinnerOverlay />}
        </>
    );
}
export default DeleteItemRevisionPopup;
